export default __webpack_public_path__ + "static/media/logos.fa342e64.svg";